<template>
  <div class="menu-fixed">
    <div id="error" class="error">
      <button @click.prevent="fecharTelaMensagens()">
        <img src="../assets/imagens/icon-close.png" alt="Botão de fechar" class="botao-fechar">
      </button>
      <h2>Não foi possível salvar, pois:</h2>
      <ul>
        <template v-if="isObject">
          <li v-for="(mensagem, index) in filteredMessages" :key="index">
            {{ mensagem }}
          </li>
        </template>
        <template v-else>
          <li>{{ mensagens }}</li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MsgErroFormularios",
  props: {
    mensagens: {
      type: [Object, String],
      required: true
    }
  },
  computed: {
    isObject() {
      return typeof this.mensagens === 'object' && !Array.isArray(this.mensagens);
    },
    filteredMessages() {
      if (this.isObject) {
        return Object.values(this.mensagens).filter(value => value !== null && value !== '');
      }
      return this.mensagens;
    }
  },
  methods: {
    fecharTelaMensagens() {
      this.$emit("fechar-erro");
    }
  }
};
</script>




<style lang="scss" scoped>
.error {
  background: #fff5f5;
  border: 1px solid #f3c1c1;
  border-left: 4px solid #d64545;
  border-radius: 0.75rem;
  padding: 0.85rem 1rem 0.95rem;
  margin-bottom: 1rem;
  text-align: left;
  box-shadow: 0 6px 18px rgba(180, 40, 40, 0.06);

  button {
    float: right;
    margin: 0.1rem 0 0 0.5rem;
    border: none;
    background-color: transparent;
    opacity: 0.7;

    .botao-fechar {
      width: 0.9rem;
    }

    &:hover {
      opacity: 1;
    }
  }

  h2 {
    display: block;
    font-size: 1rem;
    padding-left: 0.15rem;
    margin: 0.15rem 0 0.65rem;
    font-weight: 700;
    color: #9b2c2c;
    font-family: "Montserrat-Bold", "Montserrat", sans-serif;
  }

  ul {
    display: block;
    list-style-type: disc;
    margin: 0;
    padding-inline-start: 1.35rem;

    li {
      font-size: 0.9rem;
      display: list-item;
      text-align: left;
      color: #5c2a2a;
      background: transparent;
      font-family: "Montserrat-Medium", "Montserrat", sans-serif;
      margin: 0.25rem 0;
      line-height: 1.4;
    }
  }
}
</style>